import { render, staticRenderFns } from "./EventUserInformation.vue?vue&type=template&id=1997d19f&scoped=true"
import script from "./EventUserInformation.vue?vue&type=script&lang=js"
export * from "./EventUserInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1997d19f",
  null
  
)

export default component.exports